import { MATERIAL_TYPES } from '@mixtiles/web-backend-shared'

export const AVAILABLE_MATERIALS: MATERIAL_TYPES[] = [
  MATERIAL_TYPES.FRAMELESS,
  MATERIAL_TYPES.CLASSIC,
  MATERIAL_TYPES.WIDE_FRAME,
  MATERIAL_TYPES.CANVAS,
]

class MaterialsAsColorManager {
  isEnabled: boolean = false

  init(isEnabled: boolean) {
    this.isEnabled = isEnabled
  }
}

export const materialsAsColorManager = new MaterialsAsColorManager()
